<template>
  <div class="home">
    <swiper class="banner" :options="bannerSwiperOptions">
      <swiper-slide v-for="(item,index) in bannerList" :key="index">
        <img :src="$global.imageUrl + item.photoUrl" >
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
    <div class="width1200">
      <el-tabs class="home-tabs" v-model="tabIndex" @tab-click="tabChange">
        <el-tab-pane>
          <div class="tab el-row--flex is-justify-center" slot="label">
            <img src="/static/images/icon/icon-scheduling-selected.png" v-if="tabIndex == '0'" >
            <img src="/static/images/icon/icon-scheduling.png" v-else >
            <div>
              <div>运力调度</div>
              <div>多个车辆已入驻平台，可线上直接 调度,有效提升找车效率、降低物流 成本</div>
            </div>
          </div>
          <!-- 用户管理 -->
        </el-tab-pane>
        <el-tab-pane>
          <div class="tab el-row--flex is-justify-center" slot="label">
            <img src="/static/images/icon/icon-visual-selected.png" v-if="tabIndex == '1'" >
            <img src="/static/images/icon/icon-visual.png" v-else >
            <div>
              <div>可视化运输</div>
              <div>车辆实施位置跟踪，致力掌握在途货物信息</div>
            </div>
          </div>
          <!-- 配置管理 -->
        </el-tab-pane>
        <el-tab-pane>
          <div class="tab el-row--flex is-justify-center" slot="label">
            <img src="/static/images/icon/icon-management-selected.png" v-if="tabIndex == '2'" >
            <img src="/static/images/icon/icon-management.png" v-else >
            <div>
              <div>运输管理</div>
              <div>运输管理系统简单易操作，支持承运商、物流企业等多种业务模式，实现物流综合的高效协同</div>
            </div>
          </div>
          <!-- 角色管理 -->
        </el-tab-pane>
      </el-tabs>
    </div>
    <div class="box">
      <div class="title">互联网物流服务解决方案</div>
      <div class="sub-title">致力于为客户提供“成本更低、时效更快、质量更优”的物流服务</div>
      <div class="program-box">
        <div class="program-top-box el-row--flex is-justify-space-between">
          <div class="program">
            <img src="/static/images/icon/icon-program-1.png" >
            <div>运输管理</div>
          </div>
          <div class="program">
            <img src="/static/images/icon/icon-program-2.png" >
            <div>运输可视化</div>
          </div>
          <div class="program">
            <img src="/static/images/icon/icon-program-3.png" >
            <div>大数据分析</div>
          </div>
        </div>
        <div class="program-center-box el-row--flex is-justify-space-between is-align-middle">
          <div class="program">
            <img src="/static/images/icon/icon-program-7.png" >
            <div>发货方</div>
          </div>
          <div class="program">
            <img src="/static/images/icon/icon-program-8.png" >
            <div>平台</div>
          </div>
          <div class="program">
            <img src="/static/images/icon/icon-program-9.png" >
            <div>司机</div>
          </div>
          <div class="program">
            <img src="/static/images/icon/icon-program-10.png" >
            <div>收货方</div>
          </div>
        </div>
        <div class="program-bot-box el-row--flex is-justify-space-between">
          <div class="program">
            <img src="/static/images/icon/icon-program-4.png" >
            <div>支付平台</div>
          </div>
          <div class="program">
            <img src="/static/images/icon/icon-program-5.png" >
            <div>供应商服务</div>
          </div>
          <div class="program">
            <img src="/static/images/icon/icon-program-6.png" >
            <div>平台支付</div>
          </div>
        </div>
      </div>
    </div>
    <div class="box haveBg">
      <div class="title">了解我们的产品服务</div>
      <div class="sub-title">全场景整体链路的网络货运产品，提升企业知名度</div>
      <div class="width1200">
        <swiper :options="productSwiperOptions">
          <swiper-slide class="el-row--flex is-justify-center" v-for="(item, index) in productList" :key="index">
            <div class="home-product">
              <img :src="item.img1" class="home-product-img-1">
              <img :src="item.img2" class="home-product-img-2">
              <div class="home-product-title">{{item.title}}</div>
              <div class="home-product-sub-title">{{item.subTitle}}</div>
              <div class="home-product-detail el-row--flex">
                <img class="home-product-detail-img" src="/static/images/icon/icon-detail-product.png" >
                <div class="home-product-detail-btn" @click="$router.push(item.url)">查看详情</div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
      </div>
    </div>
    <div class="box">
      <div class="title">打造功能强大、稳定领先平台</div>
      <div class="sub-title">完善的操作流程，专业的技术团队，快速的响应</div>
      <div class="width1200 el-row--flex is-justify-space-between">
        <div class="advantage">
          <img src="/static/images/icon/icon-advantage-1.png" >
          <div class="advantage-title">支持多企业使用场景</div>
          <div class="advantage-sub-title">结合实际情况，个性化服务</div>
        </div>
        <div class="advantage">
          <img src="/static/images/icon/icon-advantage-2.png" >
          <div class="advantage-title">成本低，效率高</div>
          <div class="advantage-sub-title">解决企业运输困难，加强整个物流过程监管</div>
        </div>
        <div class="advantage">
          <img src="/static/images/icon/icon-advantage-3.png" >
          <div class="advantage-title">数字化转型</div>
          <div class="advantage-sub-title">促进企业物流向物流企业转型，通过对资源、平台的整合，提高企业知名度</div>
        </div>
        <div class="advantage">
          <img src="/static/images/icon/icon-advantage-4.png" >
          <div class="advantage-title">税务合规</div>
          <div class="advantage-sub-title">平台为个体司机代开增值税发票，解决进项问题</div>
        </div>
      </div>
    </div>
    <div class="partner-box">
      <div class="partner-title">
        <span>合作伙伴</span>
      </div>
      <div class="width1200 el-row--flex is-justify-space-between">
        <img src="/static/images/icon/icon-partner-1.png" >
        <img src="/static/images/icon/icon-partner-2.png" >
        <img src="/static/images/icon/icon-partner-3.png" >
        <img src="/static/images/icon/icon-partner-4.png" >
        <img src="/static/images/icon/icon-partner-6.png" >
      </div>
    </div>
  </div>
</template>

<script>
  // import Swiper2, { Pagination, Autoplay } from 'vue-awesome-swiper'
  // Swiper2.use([Pagination, Autoplay])

  export default {
    data() {
      return {
        bannerList: [],
        bannerSwiperOptions: {
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          }
        },
        productSwiperOptions: {
          slidesPerView: 3,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        tabIndex: 0,
        productList: [
          {
            img1: '/static/images/product-1.png',
            img2: '/static/images/product-1-hover.png',
            title: '网络货运 · 司机端',
            subTitle: '司机可直观的查看运单及详情，可实现在线签约，并支持更换其他车辆信息， 解决同司机不同车辆的一大难题。',
            url: '/product?tab=0'
          }, {
            img1: '/static/images/product-2.png',
            img2: '/static/images/product-2-hover.png',
            title: '网络货运 · 业务员端',
            subTitle: '业务员通过扫码登录小程序，切换至到相应的企业进行：查看运单、创建运单、向司机推送运单信息等操作。',
            url: '/product?tab=1'
          }, {
            img1: '/static/images/product-3.png',
            img2: '/static/images/product-3-hover.png',
            title: '网络货运 · 平台端',
            subTitle: '可实现创建运单、轨迹查询、运费结算等流程，帮助物流企业、平台(成易网运)、司机三方实现信息的互联互通。',
            url: '/product?tab=2'
          }, {
            img1: '/static/images/product-4.png',
            img2: '/static/images/product-4-hover.png',
            title: 'ETC数据服务平台',
            subTitle: '根据企业实际运单，通过信息化系统实现与国家路网中心对接，帮助物流企业解决获取运单ETC发票困难的问题。',
            url: '/product/etc'
          }, {
            img1: '/static/images/product-5.png',
            img2: '/static/images/product-5-hover.png',
            title: 'WMS仓储管理平台',
            subTitle: '通过入库等综合实现批次管理等的管理系统，进而有效控制并跟踪仓库业务的实现完善的企业仓储信息管理。',
            url: '/product/wms'
          }, {
            img1: '/static/images/product-6.png',
            img2: '/static/images/product-6-hover.png',
            title: 'TMS物流管理平台',
            subTitle: '从接收客户订单、电子协议签订等相关报表体系及相应的成本分析，为管理层日常业务全流程监控提供了技术支持。',
            url: '/product/tms'
          }
        ]
      }
    },
    mounted() {
      this.$global.axios.get(this, '/sywl/banner/listPage', {}, res => {
        this.bannerList = res.data;
      })
    },
    methods: {
      tabChange(tab, e) {
        this.tabIndex = tab.index;
      }
    }
  }
</script>

<style lang="scss">
  .home {
    .swiper-container {
      .swiper-slide {
        height: 630px;
    
        &-active { z-index: 2; }
      }
    
      .swiper-pagination-bullet {
        width: 24px;
        height: 6px;
        border-radius: 0;
        background-color: #66acff;
        opacity: 1;
    
        &.swiper-pagination-bullet-active {
          background-color: #fff;
        }
      }
    }
    
    .home-tabs.el-tabs {
      margin-top: -43px;
    
      .el-tabs__nav-wrap:after { background-color: transparent; }
    
      .el-tabs__active-bar { display: none; }
    
      .el-tabs__item {
        height: auto;
        padding: 0;
    
        &.is-active {
          .tab {
            background: linear-gradient(50deg, #37A9FF, #396FFF);
    
            & > div {
              color: #fff;
    
              div + div {
                color: #fff;
              }
            }
          }
        }
    
        .tab {
          width: 400px;
          height: 170px;
          padding: 25px 28px;
          box-sizing: border-box;
          background-color: #f5f9ff;
    
          img {
            width: 58px;
            height: 58px;
            margin-right: 21px;
          }
    
          & > div {
            width: 265px;
            font-size: 20px;
            color: #333;
            white-space: normal;
            text-align: left;
    
            div + div {
              margin-top: 10px;
              font-size: 15px;
              line-height: 20px;
              color: #666;
            }
          }
        }
      }
    }
    
    .program-box {
      width: 869px;
      height: 438px;
      margin: 114px auto 153px;
      background-image: url(/static/images/bg-home-line.png);
      background-size: cover;
    
      img {
        display: block;
      }
    
      .program {
        font-size: 20px;
        color: #1875f0;
    
        div { margin-top: 25px; }
    
        &:hover {
          background-image: url(/static/images/icon/icon-program-shadow-1.png);
          background-position: center 56px;
          background-repeat: no-repeat;
        }
      }
    
      .program-top-box {
        position: relative;
        top: -40px;
        width: 598px;
        margin: 0 auto;
      }
    
      .program-center-box {
        position: relative;
        top: -40px;
        margin: 21px -92px 40px -115px;
    
        div { margin-top: 10px; }
    
        & > div:nth-child(2),
        & > div:nth-child(3) { color: #5a5bce; }
    
        & > div:nth-child(2) { margin-left: -48px; }
    
        & > div:nth-child(3) { margin-right: -75px; }
      }
    
      .program-bot-box {
        position: relative;
        top: -40px;
        width: 598px;
        margin: 0 auto;
    
        .program {
          color: #ff753c;
    
          &:hover {
            background-image: url(/static/images/icon/icon-program-shadow-2.png);
          }
        }
      }
    }
    
    .haveBg {
      height: 789px;
      padding-bottom: 42px;
      background-image: url(/static/images/bg-home.png);
      background-position: center;
      box-sizing: border-box;
    
      .swiper-container {
        height: 504px;
    
        .swiper-pagination-bullet {
          background-color: #37a9ff;
    
          &.swiper-pagination-bullet-active {
            width: 48px;
            background-color: #1875f0;
          }
        }
      }
    }
    
    .home-product {
      width: 328px;
      height: 415px;
      background-color: #fff;
    
      &:hover {
        height: 444px;
        transform: translateY(-10px);
        border-bottom: 8px solid #378ffe;
        box-shadow: 0px 16px 18px 0px rgba(102, 102, 102, 0.15);
    
        .home-product-img-1 { display: none; }
    
        .home-product-img-2 { display: block; }
    
        .home-product-detail {
          margin-top: 20px;
          justify-content: center;
    
          &-img {
            display: none;
          }
    
          &-btn {
            display: block;
          }
        }
      }
    
      &-img-2 { display: none; }
    
      &-title {
        margin-top: 25px;
        font-size: 20px;
        color: #333;
      }
    
      &-sub-title {
        width: 238px;
        margin: 18px auto 0;
        font-size: 14px;
        color: #333;
      }
    
      &-detail {
        margin-top: 60px;
        justify-content: flex-end;
    
        &-img {
          margin-right: 23px;
        }
    
        &-btn {
          display: none;
          width: 120px;
          height: 36px;
          line-height: 36px;
          background: #1875F0;
          border-radius: 18px;
          font-size: 14px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
    
    .advantage {
      padding-bottom: 67px;
    
      &-title {
        margin-top: 45px;
        font-size: 20px;
        color: #333;
      }
    
      &-sub-title {
        max-width: 196px;
        margin-top: 18px;
        font-size: 14px;
        color: #666;
      }
    }
    
    .partner-box {
      padding: 66px 0 68px;
      background-color: rgba($color: #378ffe, $alpha: .05);
    
      .partner-title {
        margin-bottom: 32px;
        padding-bottom: 16px;
        font-size: 25px;
        color: #333;
    
        span {
          padding-bottom: 16px;
          border-bottom: 2px solid #378ffe;
        }
      }
    
      .width1200 {
        width: 992px;
        flex-wrap: wrap;
      }
    
      img {
        width: 144px;
        height: 88px;
        margin-top: 34px;
    
        &:hover {
          box-shadow: 0px 6px 10px 0px rgba(193, 193, 193, 0.31);
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home.vue